import React from "react";
import { FormControlLabel, FormLabel, FormGroup, FormControl } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import { useStyles } from "../../../assets/styles";

export default function CustomCheckboxMultiple(props) {
	const { handleChange, value, data } = props;
	const { label, id, options } = data;
	const allDays = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
	const values = value[0] === "all" ? allDays : value;

	const handleLocalChange = (e) => {
		const { name, checked } = e.target;
		let newValues = [];
		const temporalValues = values.filter((value) => value !== name);
		if (checked) {
			newValues = [...temporalValues, name];
		} else {
			newValues = temporalValues;
		}
		newValues = newValues.length === 7 ? ["all"] : newValues;
		const synthethicEvent = { target: { name: id, value: newValues } };
		handleChange(synthethicEvent);
	};

	const classes = useStyles();
	return (
		<FormControl className={classes.formControl}>
			<FormLabel component="legend">{label}</FormLabel>
			<FormGroup className={classes.formGroup}>
				{options.map((day) => {
					const isChecked = values.some((value) => day.id === value);

					return (
						<FormControlLabel
							key={day.id}
							control={<Checkbox checked={isChecked} onChange={handleLocalChange} name={day.id} />}
							label={day.label}
						/>
					);
				})}
			</FormGroup>
		</FormControl>
	);
}
